<template>
  <div style="display:flex;align-items: center">
    <div :style="itemStyle">{{hourString}}</div>
    <div style="padding: 2.5px">: </div>
    <div :style="itemStyle">{{minuteString}}</div>
    <div style="padding: 2.5px">: </div>
    <div :style="itemStyle">{{secondString}}</div>
  </div>
</template>

<script>
    export default {
      name: 'countdown',
      data () {
        return {
          hour: '',
          minute: '',
          second: '',
          promiseTimer: ''
        }
      },
      props: {
        remainTime: {    // 倒计时间总秒数
          default: ''
        },
        itemStyle: {
          default: ''
        }
      },
      mounted () {
        if (this.remainTime > 0) {
          let t = this.remainTime / 1000
          this.hour = Math.floor((t / 3600))
          this.minute = Math.floor((t / 60) % 60)
          this.second = Math.floor(t % 60)
          this.countDowm()
        }
      },
      methods: {
        countDowm () {
          let self = this
          clearInterval(this.promiseTimer)
          this.promiseTimer = setInterval(function () {
            if (self.hour === 0) {
              if (self.minute !== 0 && self.second === 0) {
                self.second = 59
                self.minute -= 1
              } else if (self.minute === 0 && self.second === 0) {
                self.second = 0
                self.$emit('countDowmEnd', true)
                clearInterval(self.promiseTimer)
              } else {
                self.second -= 1
              }
            } else {
              if (self.minute !== 0 && self.second === 0) {
                self.second = 59
                self.minute -= 1
              } else if (self.minute === 0 && self.second === 0) {
                self.hour -= 1
                self.minute = 59
                self.second = 59
              } else {
                self.second -= 1
              }
            }
          }, 1000)
        },
        formatNum (num) {
          return num < 10 ? '0' + num : '' + num
        }
      },
      computed: {
        hourString () {
          return this.formatNum(this.hour)
        },
        minuteString () {
          return this.formatNum(this.minute)
        },
        secondString () {
          return this.formatNum(this.second)
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/goods/countdown.vue